import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { ArquivoUploadCardViewModule } from '../../../arquivos/arquivos/upload/components/card-view';
import { ArquivoCardViewModule } from '../../../arquivos/arquivos/components/card-view';
import { ClienteArquivoComponent } from './cliente-arquivo.component';

@NgModule({
    imports: [
        SharedModule,
        ArquivoUploadCardViewModule,
        ArquivoCardViewModule
    ],
    declarations: [
        ClienteArquivoComponent
    ],
    exports: [
        ClienteArquivoComponent
    ]
})
export class ClienteArquivoModule { }
